export default {
  // Menu items
  home: "Home",
  helpCenter: "Help Center",

  // Help center submenu
  productFunction: "Product Features",
  nationalInvolvement: "Judicial Case Reference",
  prosecuteBook: "Indictment",
  policyRegulation: "Policies and Regulations",
  blockchainKnowledge: "Blockchain Industry Knowledge",
  blockchainCaseInvestigation: "Blockchain Case Investigation Records",

  // Data screen
  dataScreen: "Data Dashboard",

  // User dropdown menu
  userCenter: "User Center",
  userFeedback: "User Feedback",
  logout: "Logout",

  // Role
  systemAdmin: "System Administrator",

  // Default values
  noPhoneNumber: "No phone number",
};
